/**
 * TierNotice — a slim note at the top of a tool that's above the viewer's
 * plan: "Promo Hub is part of Serve and up". The page still renders, so
 * anything they already made stays viewable; making something new is refused
 * by the server (middleware requireTier) with the same message.
 *
 * Showrunner, Slide Decks, Premieres, A/B Testing, QR Codes and Promo Hub
 * moved from Build to Serve in Oct 2026. Trials and admins never see it
 * (utils/planAccess treats a trial as Serve).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { hasPlanAccess } from '../utils/planAccess';
import './TierNotice.css';

const PLAN_NAMES = { starter: 'Build', professional: 'Serve', business: 'Studio', scale: 'Scale' };

export default function TierNotice({ plan = 'professional', feature, children }) {
  const { currentUser, getSubscriptionStatus } = useAuth();
  const status = getSubscriptionStatus ? getSubscriptionStatus() : {};
  const below = !!currentUser && !hasPlanAccess(currentUser, status, plan);
  const name = PLAN_NAMES[plan] || plan;
  return (
    <>
      {below && (
        <div className="tier-notice" role="note">
          <span>
            <strong>{feature}</strong> is part of {name} and up. Anything you&apos;ve already made stays here.
          </span>
          <Link to={`/pricing?plan=${plan}`} className="tier-notice-btn">Upgrade to {name}</Link>
        </div>
      )}
      {children}
    </>
  );
}
